module.exports = __webpack_public_path__ + "static/media/Golf Cover.fca64a62.png";